<template>
<main >
  <input  type="file" id="media" style="display: none"/>
        <div  style="display: none">
            {{ss}}
        </div>  

        <div  ref="element">

        </div>
		<div  id="form_container">
			<div  class="row">
				<div  class="col-lg-5">
					<div  id="left_form" style="text-align: center">
						<figure ><img  src="img/review_bg.svg" alt=""></img></figure>
						<h2 >{{qs.name}}</h2>
						<p > شانس : {{qs.chance}}</p>
						<p > امتیاز : {{qs.point}}</p>
						<a  href="#0" id="more_info" data-toggle="modal" data-target="#more-info"><i  class="pe-7s-info"></i></a>
					</div>
				</div>


				<div  class="col-lg-7">

					<div  id="wizard_container">
						<div  id="top-wizard">
							<div  id="progressbar"></div>
						</div>
						
						<div >
							<input  id="website" name="website" type="text" value=""/>
							
							<div  id="middle-wizard">
                  <div  class="submit step" style="text-align: center">
		              
                  <div id="recordingsList"></div> 
                    
                    <h4  style="text-align: justify" class="main_question">
                      <div v-if="score" style="margin-bottom: 22px;">
                        جمع امتیاز :{{score}}
                      </div>
                        <strong  v-if="qs.isViewPaging">{{counter+1}}/{{qs.questions.length}}</strong>
                      <div  v-html="convertText(ques.text)"></div>   
                      <div  v-html="trackingCode"></div>   
                    </h4>
                    
                    <span  v-if="showRequire" class="error" style="">{{chekText}}</span>
                   
                    <img  v-if="ques.url && ques.isPicture" v-bind:src="ques.url" style="width:90%"></img>
                    <video  v-if="ques.url && !ques.isPicture" width="320" height="240" controls>
                      <source :src="ques.url" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>

                    <div  v-if="ques.kind=='numberScale'"> 
                        <div  v-for="(answ,index1) in ques.answers " :key="answ.id" >
                            <div >
                                <td  style="text-align: right;    padding-bottom: 10px;padding-top: 10px;">
                                    {{answ.text}}
                                </td>
                            </div>
                        <table  style="width: 100%">
                            <tr >
                            <td  v-bind:width="(100/(getHeaders().length ))+'%'" v-for="(itms,mindex) in getHeaders() " :key="itms.id"  v-bind:style="itms.style">
                            <span >
                                {{itms.text}}

                            </span>
                            </td>

                            </tr>
                        </table> 
                        <table  style="width:100%;text-align:center;">
                               
                                     <tr  style="border-bottom:3pt solid blue;">
                                         
                                             <span  v-bind:width="(100-getMinMax(ques.minItem,ques.maxItem).length*10)+'%'" v-if="shErr[ques.id][answ.id]" class="error" style="position: relative;">اجباری</span>  
                                              
                                             <td  v-for="(itms,mindex) in getMinMax(ques.minItem,ques.maxItem) " :key="itms.id" > 
                                                     
                                                 <div  v-if="myansw[ques.id][answ.id] != itms" class="col-lg-1 col-2" v-on:click="numberClick(ques.id,answ.id,itms)" style="border-width: 2px;width: 30px;border-style: solid;height: 30px;border-color: #5e76ed;cursor: pointer; top: 50%;transform: translate(-50%, 0%);">
                                                      
                                                     
                                                         {{itms}}
                                                      
                                                 
                                                 </div>
         
                                                 <span >
                                                     
                                                 <div  v-if="myansw[ques.id][answ.id] == itms" class="col-lg-1 col-2" v-on:click="numberClick(ques.id,answ.id,itms)" style="border-width: 2px;width: 30px;border-style: solid;height: 30px;border-color: #5e76ed;background: blue;cursor: pointer; top: 50%;transform: translate(-50%, 0%);">
                                                     
                                                     
                                                         {{itms}} 
                                                 
                                                 </div>
                                                 </span>
     
                                             </td> 
                                     </tr> 
                                     
                        </table> 
                        </div>

                    </div>
 
                   
                    <table  v-if="ques.kind!='endpage' && ques.kind!='page' && ques.kind!='numberScale'" 
                            style="text-align: right;" class="col-lg-12">
                        
                        <template  v-for="(answ,index1) in ques.answers "   >
                           
                            <tr >  
                                <td  v-if="ques.showNumber">
                                    {{index1+1}}
                                </td>
                                    
                                <td  v-if="answ.url" style="width: 45px;">
                                    <img  v-bind:src="answ.url" style="width: 40px;"></img>
                                </td> 
                                <td  v-if="!ques.place &&  !(ques.kind=='radio'|| ques.kind=='check'|| ques.kind=='priority')">
                                    {{answ.text}}
                                </td>
                                <td  v-if="(ques.kind=='singleLine' || ques.kind=='email' || ques.kind=='link') && !answ.isOther">
                                    <span  v-if="shErr[ques.id][answ.id]" class="error" style="position: relative;">اجباری</span>  
                                    <input  v-if="ques.place" type="text" class="form-control" v-model="myansw[ques.id][answ.id]" v-bind:placeholder="answ.text"/>

                                    <input  v-if="!ques.place" type="text" class="form-control" v-model="myansw[ques.id][answ.id]"/>
                                            
                                </td>
                                <td v-if="ques.kind=='file'">  
                                  <uploader :questionId="qs.id" v-model="myansw[ques.id][answ.id]" @input="ss++"  />
                                </td>
                                
                                <td  v-if="(ques.kind=='int' || ques.kind=='decimal') && !answ.isOther">
                                    <span  v-if="shErr[ques.id][answ.id]" class="error" style="top:-20px">اجباری</span>  
                                    <input  v-if="ques.place" type="number" class="form-control" inputmode="numeric" pattern="[0-9]*" v-on:keyup="keyupp($event)" lang="en-150" v-on:change="replaceNumber(answ.id,$event)" v-model="myansw[ques.id][answ.id]" v-bind:placeholder="answ.text"/>

                                    <input  v-if="!ques.place" v-on:keyup="keyupp($event)" v-on:change="replaceNumber(answ.id,$event)" type="number" inputmode="numeric" pattern="[0-9]*" lang="en-150" class="form-control" v-model="myansw[ques.id][answ.id]"/>
                                    <div  style="float: left;">

                                        {{getSeperated(myansw[ques.id][answ.id])}}       
                                    </div>     

                                </td>
                                <td  v-if="ques.kind=='multiLine' && !answ.isOther">
                                    <span  v-if="shErr[ques.id][answ.id]" class="error" style="top:-20px">اجباری</span>  
                                    <textarea  v-if="ques.place" type="text" class="form-control" v-model="myansw[ques.id][answ.id]" v-bind:placeholder="answ.text"></textarea>

                                    <textarea  v-if="!ques.place" type="text" class="form-control" v-model="myansw[ques.id][answ.id]"></textarea>
                                </td>

                                
                                <td  v-if="ques.kind=='dateTime' && !answ.isOther">
                                    <span  v-if="shErr[ques.id][answ.id]" class="error" style="top:-20px">اجباری</span>  
                                    
                                    <date-picker  v-model="myansw[ques.id][answ.id]" v-bind:clearable="true"></date-picker>
                                </td>
                                <td  v-if="ques.kind=='linearScale' && !answ.isOther">
                                    <span  v-if="shErr[ques.id][answ.id]" class="error" style="top:inherit">اجباری</span>  
                                    <div  style="direction: ltr">  
    
                                            <tool-rating  v-bind:id="answ.id" v-bind:number="ques.pointerNumber" v-bind:shape="getPointer(ques.pointerType)" v-bind:selected="myansw[ques.id][answ.id]" v-on:selectedChange="ratechange"></tool-rating>


                                            
            
                                    </div>
                                </td>
                                <td  v-if="ques.kind=='numberScale' && !answ.isOther">
                                    <span  v-if="shErr[ques.id][answ.id]" class="error" style="top:-20px">اجباری</span>  
                                    <div  class="col-lg-9 col-10">
                                        <table >
                                            <tr  v-if="answ.header">
                                                <td  v-for="(hdr,hdri) in answ.header " :key="hdr.id" >
                                                    {{hdr.text}}
                                                </td>
                                            </tr>
                                            <tr >
                                                <td  v-for="(itms,mindex) in getMinMax(ques.minItem,ques.maxItem) " :key="itms.id" > 
                                                            
                                                    <div  class="col-lg-1 col-2" v-on:click="itmClick(ques.id,answ.id)" style="width: 30px;border-style: solid;height: 30px;border-color: #5e76ed;">
                                                        <span >
                                                        
                                                            {{itms}}
                                                        </span>
                                                    
                                                    </div>
                                                </td> 
                                            </tr>
                                        </table> 
            
                                    </div>
                                </td>
                                <td  v-if="ques.kind=='radio' && !answ.isOther">
                                    <div  class="form-group radio_input">
                                        <label  v-on:click="radioClick(ques.id,answ.id)" style="width: 100%">  
                                            <div  class="row">
                                                    <div  class="col-1 radiouncheck" v-if="!myansw[ques.id][answ.id]"></div>
                                                    <div  class=" col-1 radiocheck" v-if="myansw[ques.id][answ.id]"></div> 
                                                    <span  class=" col-10">
                                                        
                                                    {{answ.text}}
                                                    </span>

                                                </div>    
                                        </label>
                                    </div>
                                </td>
                                <td  v-if="ques.kind=='check' && !answ.isOther">  
                                        <div  class="form-group radio_input">
                                                <label  v-on:click="checkClick(ques.id,answ.id)" style="width: 100%">
                                                <div  class="row">
                                                    <div  class="col-1 checkboxuncheck" v-if="!myansw[ques.id][answ.id]"></div>
                                                    <div  class=" col-1 checkboxcheck" v-if="myansw[ques.id][answ.id]"></div> 
                                                    <span  class=" col-10">
                                                        
                                                    {{answ.text}}
                                                    </span>

                                                </div>   
                                                </label>
                                            </div>
                                </td>
                                <td  v-if="ques.kind=='priority' && !answ.isOther">
                                    <div  class="row">
                                    
                                        <div  class="col-lg-1 col-2" v-on:click="itmClick(ques.id,answ.id)" style="width: 30px;border-style: solid;height: 30px;border-color: #5e76ed;">
                                            <span >
                                            
                                                {{myansw[ques.id][answ.id]}}
                                            </span>
                                        
                                        </div>
                                        <div  class="form-group radio_input col-lg-10 col-9">
                                            <label > 
                                                {{answ.text}}
                                            </label>
                                        </div>
                                        
                                    </div>
                                </td>
                                <td  v-if="answ.isOther"> 
                                        <div  class="form-group radio_input">
                                            <label  style="width: 100%">
                                                <div  class="row"> 
                                                    <div  class=" col-2 ">
                                                        <span  v-if="!ques.place ">
                                                            
                                                    {{answ.text}}
                                                        </span>
                                                    </div> 
                                                    <span  class=" col-10">
                                                        
                                                        <input  v-if="ques.place" type="text" class="form-control" v-model="myansw[ques.id][answ.id]" v-bind:placeholder="answ.text"/>
                                                        <input  v-if="!ques.place" type="text" class="form-control" v-model="myansw[ques.id][answ.id]"/>
                                                    </span>

                                                </div>    
                                            </label>
                                        </div>


    

                                </td>

                            </tr>
                            <tr  v-if="answ.url">
                                <td  colspan="5" style="text-align: center;"> 

                                    <img  v-bind:src="answ.url" style="width: 100%;"></img>
                                </td>
                            </tr>
                            <tr  style="border-bottom:3pt solid blue;" v-if="(ques.kind=='int' || ques.kind=='decimal')||answ.url ">
                                <td  colspan="5"></td>
                            </tr>
                        </template>
                    </table>     


                    <div  style="position: absolute;top:-1000px">
                            <div  class="col-lg-1 checkboxuncheck"></div>
                            <div  class=" col-lg-1 checkboxcheck"></div>  
                            <img  class="radiouncheck"></img>
                            <img  class="radiocheck"></img>
                    </div>

                    

                    
                    
                    
                    
                    

                    
                      <div  style="display: none">

                      {{cc}}
                      </div>

                    
                    <div  class="col-lg-12" style="text-align: center" v-if="ques.kind=='page'">   
                        <div  class="col-lg-12"> 
                            {{ques.description}}
                        </div> 
                        <div  class="col-lg-12 " v-for="(answ,index1) in ques.answers " :key="answ.id" > 
                            <button  type="button" v-on:click="nextPage()" class="forward">{{ques.buttonTitle}}</button>
                        </div>
                    </div>


                    <div  class="col-lg-12" style="text-align: center" v-if="ques.kind=='endpage'">   
                        <div  class="col-lg-12"> 
                            {{ques.description}}
                        </div> 
                        <div  class="col-lg-12 " v-for="(answ,index1) in ques.answers " :key="answ.id" > 
                            <button  v-if="!issend" type="button" v-on:click="submit()" class="forward">{{answ.text}}</button>
                        </div>
                    </div>

                  </div>
								
							</div>
							
							<div >
								<button  type="button" v-on:click="backPage()" v-if="!isEnd && counter!=1 && counter!=0 && ques.canBack" class="backward">قبلی </button>
								<button  type="button" v-on:click="nextPage()" v-if="!isEnd && counter!=0" class="forward">بعدی</button>
								
							</div>
							
            </div>
					</div>
					
				</div>
			</div>
		</div>
	</main>
</template>



<script>
import pages from './components/pages.vue'
import uploader from './components/uploader.vue'
export default {
  name:'home',
    components:{pages,uploader},  
      data:function()
      {
        return {
          startDate:"",
          trackingCode:"",
          pushtoNext:[],
          score:0,
          showQuestion:{},
          gconds:{},
          qs:{"questions":[]},
          counter:0,
          myansw:{},
          shErr:{},
          ques:{},
          isEnd:false,
          isPublic:false,
          mm:"1397/02/02",
          cc:0,
          showRequire:false,
          chekText:"",
          ss:0,
          mtxt:"",
          thisId:"",
          questionAnsw:{},
          issend:false,
          element:{},
          shape:[0,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17],

        }
      },
      
    
    methods: { 
      getElementByRef:function(el){
        return this.$refs[el]
      },
      getMyParent:function(obj){return this.$parent},
      setState:function(obj){
        var al={}
        if(obj)
          for(var a in obj)
          {
            //if(al[a])
            //  continue
            try{
              this[a]=obj[a] 
            }catch(exp){}
          }
          
      },
      getSeperated:function (num)
    {
      if(!num)
        return""
      var c=0
      var ch="";
      for(var a=num.length-1;a>0;a--)
      {
        c++;
        ch=num[a]+ch
        if(c==3)
        {
          c=0
          ch=","+ch
        }
      }
      if(num.length)
        ch= num[0]+ch
      return ch
    },
        ratechange:function (data){
      this.myansw[this.ques.id][data.id]=data.index
      //console.log('>>>>>>',data)
    },
        getPointer:function (name)
    {
      if(name.indexOf("star")>-1)
      {
        return "fa-star";
      }
      if(name.indexOf("thumbs")>-1)
      {
        return "fa-thumbs-up";
      }
      if(name.indexOf("heart")>-1)
      {
        return "fa-heart";
      }
    },
    keyupp:function (event){
        var ew = event.which;
        this.ss++;
        this.showRequire=false 
        if(event.which)
        {
          this.mtxt='is '+event.which
        }
        else
        {
          this.mtxt="noalue"
          this.chekText="لطفا عدد انگلیسی وارد کنید";
        }
        if(ew == 32)
            return true;
        if(48 <= ew && ew <= 57)
            return true;
        // if(65 <= ew && ew <= 90)
        //     return true;
        // if(97 <= ew && ew <= 122)
        //     return true; 
            this.showRequire=true 
          this.chekText="لطفا عدد انگلیسی وارد کنید";
        return false;
    },
    replaceNumber:function (id,eve){
      //console.log('------------------>',eve.target.value)

      var txt=this.myansw[this.ques.id][id];
      var ntext=""
      if(eve.which)
      {
        this.mtxt=eve.which
      }
      else
      {
        this.mtxt="noalue"
      }
      
      for(var  x in txt)
      {
        var a= txt[x];
        if(a=="٠")a="0";
        if(a=="١")a="1";
        if(a=="٢")a="2";
        if(a=="٣")a="3";
        if(a=="٤")a="4";
        if(a=="٥")a="5";
        if(a=="٦")a="6";
        if(a=="٧")a="7";
        if(a=="٨")a="8";
        if(a=="٩")a="9";
        if(a=="۰")a="0";
        if(a=="۱")a="1";
        if(a=="۲")a="2";
        if(a=="۳")a="3";
        if(a=="۴")a="4";
        if(a=="۵")a="5";
        if(a=="۶")a="6";
        if(a=="۷")a="7";
        if(a=="۸")a="8";
        if(a=="۹")a="9";
        ntext+=a;
      }
       
      //console.log('hhhhhhhhhh',ntext)
      this.myansw[this.ques.id][id]=ntext
      this.ss++;
    },
    getAllSubCond:function (cond){
      if(cond.children && cond.children.length)
      {
        this.gconds[cond.id]={questionnaireId:cond.questionnaireId,questionId:cond.questionId,cond:cond,value:{}}
      }
    },
    getAllCond:function (conds){
      var arr=[]
      for(var b in conds)
      {
        var a=conds[b]
        this.getAllSubCond(a.subCond);
      }
    },
    postCond:function (){
      var cnds=[]
      for(var a in this.gconds)
      {
        var b=this.gconds[a]
        cnds.push({questionnaireId:b.questionnaireId,questionId:b.questionId})
      } 
    },
    rebuildCondition:function (){
      for(var a in this.gconds)
      {
        var b=this.gconds[a]
        if(b.questionnaireId==this.thisId)
        {
          if(this.myansw[b.questionId])
          {
             
          }
        }

      }
    },
    getHeaders:function (){
      var arr=[]
      for(var b= this.ques.maxItem;b>=this.ques.minItem-1   ;b--)
      {
        var style='text-align: center;'
        if(this.ques.header['a'+b])
          arr.push({text:this.ques.header['a'+b],style:style})
        
      }
      // for(var a in this.ques.header)
      // {
      //   var style='text-align: center;'
      //   if(this.ques.header[a])
      //     arr.push({text:this.ques.header[a],style:style})
      // }
      arr[0].style='text-align: right;'
      arr[arr.length-1].style='text-align: left;'
      return arr
    },
    getMyQue:function (id,aid){
      for(var a of this.qs.questions)
        //var a=this.qs.questions[jjx]
        if(a.id==id)
        {
          for(var b of a.answers)
          {
            // var b=a.answers[jjj]
            if(b.id==aid)
            {
              return b.text
            }
          }
        }
    },
    isKindeOf:function (id,aid){
      for(var a of this.qs.questions)
        //var a=this.qs.questions[jjx]
        if(a.id==id)
        {
          return a.kind[0]=='singleLine' || 
          a.kind[0]=='multiLine'||
          a.kind[0]=='int' || 
          a.kind[0]=='decimal'|| 
          a.kind[0]=='range'|| 
          a.kind[0]=='numberScale'|| a.kind[0]=='linearScale'
           
        }
    },
    checkCondition:function (cond){
      //console.log('check')
      var val=false
      var tp=cond.type
      if(tp=="and")
      {
        val=true
      }
      for(var jjx in cond.children)
      { 
        var a=cond.children[jjx]
        var v=false
        if(a.type)
        {
          var ifs=this.checkCondition(a)

          if(tp=="and" && !ifs)
          {
              console.log("and--->",ifs)  
            val=false
            //console.log()
          }
          if(tp=="or" && ifs)
          {
              console.log("or--->",ifs)  
            val=true
            break
          } 

        }
        else
        { 
          var itm={} 
          if(a.questionnaireId==this.thisId)
          {
            var answ=this.getMyQue(a.questionId,a.valueId)
            var iskindof=this.isKindeOf(a.questionId,a.valueId)
           // console.log('/////////////////////////',answ)
            itm=this.myansw[a.questionId+""]

            var mval=a.valueId
            if(a.kindof!=null && typeof(a.kindof)!="undefined" && iskindof)
            {
              mval=a.kindof
            }

            if(typeof(mval)=="number")
              mval=a.questionId+"_"+mval
            var ifs=false  
            if(a.operation =="eq")
            {
              // if(typeof(itm)=="undefined") return false; 
              if(typeof(itm)=="undefined")
              {
                ifs= false;
              }
              else
                ifs=(itm && ( (!a.value && itm[mval]) || (a.value && itm[mval]==a.value) )) 
            }
            if(a.operation =="lt")
            {
              // if(typeof(itm)=="undefined") return false;
              if(typeof(itm)=="undefined")
              {
                ifs= false;
              }
              else 
                ifs=(itm && ( (!a.value && itm[mval]) || (a.value && itm[mval]<a.value) )) 
            }
            if(a.operation =="lte")
            {
              // if(typeof(itm)=="undefined") return false;
              if(typeof(itm)=="undefined")
              {
                ifs= false;
              }
              else 
                ifs=(itm && ( (!a.value && itm[mval]) || (a.value && itm[mval]<=a.value) )) 
            }
            if(a.operation =="gt")
            {
              // if(typeof(itm)=="undefined") return false; 

              if(typeof(itm)=="undefined")
              {
                ifs= false;
              }
              else
                ifs=(itm && ( (!a.value && itm[mval]) || (a.value && itm[mval]>a.value) )) 
              console.log("gt--->",ifs)  
            }
            if(a.operation =="gte")
            {
              // if(typeof(itm)=="undefined") return false; 
              if(typeof(itm)=="undefined")
              {
                ifs= false;
              }
              else
                ifs=(itm && ( (!a.value && itm[mval]) || (a.value && itm[mval]>=a.value) )) 
            }
            if(a.operation =="ne")
            { 
              if(typeof(itm)=="undefined")
              {
                ifs= true;
              }
              else
              {
                ifs=(itm && ( (!a.value && !itm[mval]) || (a.value && itm[mval]!=a.value) ))

              }
              var ssss=0;
            }
            if(a.operation =="null")
            { 
              // if(typeof(itm)=="undefined") return true; 
              if(typeof(itm)=="undefined")
              {
                ifs= true;
              }
              else
                ifs=(itm && ( itm[mval]==null || typeof(itm[mval])=='undefined'))
              console.log("null--->",ifs)  
            }
            if(a.operation =="notnull")
            { 
              // if(typeof(itm)=="undefined") 
              //   return false; 
                
              if(typeof(itm)=="undefined")
              {
                ifs= false;
              }
              else
              {
                var existq=false
                if(itm)
                for(var ccc in itm)
                {
                  if(ccc.indexOf(a.questionId+"_")==0)
                    existq=true
                } 
                ifs=existq

              }

              var d=0;
            }
            if(tp=="and" && !ifs)
            {
              val=false
              //console.log()
            }
            if(tp=="or" && ifs)
            {
              val=true
              break
            } 
          }
          else
          {
            itm=this.gconds[a.questionnaireId][a.questionId]
          }
          
        }
      }
      return val;
    },
    reloadQuestion:function (){
      //questionAnsw
      this.questionAnsw={}
      for(var jjx1 in this.qs.questions)
      {
        var a=this.qs.questions[jjx1]
        var n=""+a.id
        this.questionAnsw[n]={}
        for(var jjx2 in a.answers)
        {
          var b=a.answers[jjx2]
          console.log('ccccccccccccccc')
          this.questionAnsw[n][a.id+'_'+b.id] ={
            min:b.min,
            max:b.max,
            score:b.score,
            id:a.id+'_'+b.id,q:a.id,a:b.id,text:b.text,expected:b.expected,url:b.url}
        }
        if(a.external)
        {
          //for(var i of this.qs.questions)
         // {
            for(var jjx3 in a.external)
            {
              var j=a.external[jjx3]
              var i = this.questionAnsw[j.id+""]
              //if(i.id==j.id)
              //{
                for(var xx in i)
                {
                  var x=i[xx]
                  var canp=false
                  if(j.type=="selected")
                  {
                    var qx=this.myansw[j.id+""]
                    if( qx && (qx[xx]!=null && typeof(qx[xx])!='undefined' && qx[xx]!=""))
                      canp=true
                  }
                  if(j.type=="notSelected"  && !x.isOther)
                  {
                    var qx=this.myansw[j.id+""]
                    if( qx && !(qx[xx]!=null && typeof(qx[xx])!='undefined' && qx[xx]!=""))
                      canp=true
                  }
                  if(j.type=="all")
                  {
                    if(x.id[0]=='o'  )
                    {
                      var qx=this.myansw[j.id+""]
                      if( qx && (qx[xx]!=null && typeof(qx[xx])!='undefined' && qx[xx]!=""))
                        canp=true
                    }
                    else
                      canp=true
                  }

                  if(canp)
                  {
                    if(x.isOther)//
                    {
                      var ss=i[x.id].q+""
                      this.questionAnsw[n][x.id]={id: x.id,q:ss,a:x.id,text:this.myansw[ss][x.id],expected:j.isStar}

                  //console.log('------->>>',j)
                    }
                    else
                    {
                    this.questionAnsw[n][x.id]={id: x.id,q:i[x.id].q,a:x.id,text:x.text,expected:j.isStar}

                  //console.log('------->>>',j)
                    }
                  }
                }
             // }
            }
          //}
        }
        if(a.other)
        {
          if(a.otherNum)
          {
            for(var x =0;x<a.otherNum;x++)
            {
              this.questionAnsw[n]['o'+a.id+'_'+x]={id:'o'+a.id+'_'+x,q:a.id,a:x,text:a.otherText,isOther:true}

            }

          }
        }
      }
    },
    radioClick:function (qid,aid){
      //console.log(qid,aid)
      this.myansw[qid] ={}
      this.myansw[qid][aid+""]=true
      var self=this
      setTimeout(function(){

      if(self.ques.autoNext)
      {
        self.nextPage();
      }
      self.ss++
      },300)
      this.ss++
      this.setState({})
    },
    checkClick:function (qid,aid){
      //console.log(qid,aid) 
      this.myansw[qid][aid+""]=!this.myansw[qid][aid+""]
      this.ss++ 
      this.setState({})
    },
    itmClick:function (qid,aid){
      this.cc++ 
      var max=0
      var qq =this.myansw[qid]
      if(qq[aid])
      { 
        for(var a in qq)
        {
          
          if(qq[a]>qq[aid])
          {
             qq[a]--
          } 
        }
            delete qq[aid]

      }
      else
      {
        for(var a in qq)
        {
          if(qq[a]>max)
          {
            max=qq[a]
          }
        }
        this.myansw[qid][aid]=max+1
      }
    },
    numberClick:function (qid,aid,number){
      //this.myansw[qid]={}
      this.myansw[qid][aid]=number
      this.ss++
    },
    getRandom(count)
    {
      var arr=[]
      for(var a=0;a<count;a++)
        arr.push(a);
      var newarr=[];
      for(var a=0;a<count;a++)
      {
        var rand=Math.floor(Math.random()*arr.length);
        var tmp=arr.splice(rand,1)
        newarr.push(tmp[0])
      }
      return newarr;
    },
    getWords(data)
    {
      var arr=[];
      var start=data.indexOf("{{")
      var count=0;
      while(start>-1)
      {
        var end=data.indexOf("}}",start)
        if(end==-1)break;
        var str=data.substr(start+2,end-start-2);
        arr.push(str);
        console.log(start)
        start=data.indexOf("{{",end)
        count++
        if(count>10)break;
      }
      return arr
    },
    convertText(data){
      var words=this.getWords(data);
        console.log('|----->',this.ques)
      // var start=data.indexOf("{{")
      // var end=data.indexOf("}}")
      for(var a of words)
      //if(start>-1 && end>-1)
      {
        var txt=a;//data.substr(start+2,end-start-2)
        var index=txt.replace("Ans_","")
        for(var a of this.qs.questions)
        {
          if(a.number==index)
          {
            var answ=this.myansw[a.id.toString()]
            var answindex=0;
            var answtitle="";

            for(var b in answ)
            {
              answindex= b.split("_")[1]
              //answtitle=answ[b]
              if(this.questionAnsw[a.id])
              {
                answtitle=this.questionAnsw[a.id][b].text
                // console.log('XXX----->',this.questionAnsw[a.id][b])
                // console.log('XXX----->',answ)
                // console.log('XXX----->',this.questionAnsw)
                // console.log('XXX----->',a)
              }
            } 
            // if(a.kind=='radio' || a.kind=='check')
            // {

            //   answtitle= a.answers.filter(p=>p.id==answindex)
            //   if(answtitle.length)
            //   {
            //     answtitle=answtitle[0].text
            //   }
              
            // } 
            data=data.replace("{{"+txt+"}}",answtitle)
            // console.log('|----->',answtitle)
            // console.log('|----->',answ)
            // console.log('|----->',a)
          }
        }
        console.log('|----->',txt)
        // console.log('|----->',this.myansw)
        // console.log('|----->',this.qs.questions)

        for(var a of this.qs.questions)
        {

        }

      }
      return data;
    },
    reload:function (){
      this.$forceUpdate()
      console.log('getcopy')
      this.ques=getCopy( this.qs.questions[this.counter] )
      //console.log('-------------------------------------',this.getRandom(this.qs.questions[this.counter].answers.length))
      if(this.ques.kind=='endpage')
      {
        this.isEnd=true
      }
      this.ques.answers=[]
      var n=""+this.ques.id

      if(this.ques.rotation)
      {
        var myarr=[];
        var oth=[]
        for(var a in this.questionAnsw[n])
        {
          if(!this.questionAnsw[n][a].isOther)
            myarr.push(this.questionAnsw[n][a]);
          else
            oth.push(this.questionAnsw[n][a]);
        }
        
      //console.log('-------------------------------------',myarr)
        var myrandom=this.getRandom(myarr.length)
        for(var a of myrandom)
        {
          this.ques.answers.push(myarr[a])
        } 
        for(var a of oth)
        {
          this.ques.answers.push(a)
        } 

      }
      else
      {
        for(var a in this.questionAnsw[n])
        {
          this.ques.answers.push(this.questionAnsw[n][a])
        }

      }
      //console.log('-------------------------------------',myrandom)

      if(!this.myansw[this.ques.id])
      {
        this.myansw[this.ques.id]={}
        this.shErr[this.ques.id]={}
      }
      var self=this
      // setInterval(function(){
      //   self.ss++
      //   self.setState({})
      // },1000)
    },
    canNext:function (){
      this.reloadQuestion()
      this.shErr[this.ques.id]={}
      this.showRequire=false
      console.log('--------------------->>---')
      //console.log(this.myansw[this.ques.id])
      //console.log(this.ques)
      if(this.ques.isStar)//isStar
      {
        var k= 0
        for(var a in this.myansw[this.ques.id])
        {
          if(this.myansw[this.ques.id][a])
            k++
        } 
        if(k==0)
        {
          this.showRequire=true
          this.chekText="این سوال اجباری است"
          return false 
        }

      }
      if(this.ques.expected )
      {
        // if(this.ques.kind=='radio')
        // {
        //   if(this.myansw[this.ques.id]>=0)
        //   {
        //      return true
        //   }
        //   this.showRequire=true
        //   this.chekText="سوال اجباری است"
        //   return false
        // }
        var k= 0
        for(var a in this.myansw[this.ques.id])
        {
          if(this.myansw[this.ques.id][a])
            k++
        } 
        //console.log('----->>---',k)
        if(this.ques.kind=='radio')
        {
          if(k==0)
          {
            this.showRequire=true
            this.chekText="این سوال اجباری است"
            return false 
          }
        }
        else if(this.ques.min)
        {
          if(k<this.ques.min)
          {
            this.showRequire=true
            this.chekText="حد اقل باید "+ this.ques.min +" مورد انتخاب شود"
            return false

          }
        }
        else
        {
          if(k<1)
          {
            this.showRequire=true
            this.chekText="حد اقل باید "+ 1 +" مورد انتخاب شود"
            return false

          }

        }
        if(this.ques.max)
        {
          if(k>this.ques.max)
          {
            this.showRequire=true
            this.chekText="حد اکثر باید "+ this.ques.max +" مورد انتخاب شود"
            return false

          }

        }

      }
      for(var jjx4 in this.ques.answers)
      {
        var a=this.ques.answers[jjx4]
        // console.log('---------------------------------')
        // console.log(a)
        // console.log(this.myansw[this.ques.id][a.id])
        // console.log(this.myansw[this.ques.id])
        if(a.expected && !this.myansw[this.ques.id][a.id])
        {
          this.shErr[this.ques.id][a.id]=true
          // console.log(this.shErr)
          this.cc++
          return false
        }
        if(a.min)
        {
          var maxx=parseInt(a.min.toString())
          var val=parseInt(this.myansw[this.ques.id][a.id].toString());
          if(maxx<val)
          {
            
            this.showRequire=true
            this.chekText='بیشترین مقدار می تواند '+ maxx+' باشد'
            return false
          }
        }
        if(a.max)
        {
          var maxx=parseInt(a.max.toString())
          var val=parseInt(this.myansw[this.ques.id][a.id].toString());
          if(maxx>val)
          {
            
            this.showRequire=true
            this.chekText='کمترین مقدار می تواند '+ maxx+' باشد'
            return false
          }
        }
        
      }
      return true
    },
    backPage:function (){
      //this.showQuestion={}
      // for(var jjx5 in  this.qs.conditions)
      // {
      //   var x=this.qs.conditions[jjx5]
      //   var cond = this.checkCondition(x.subCond)
      //   //this.qs.questions
      //   for(var jjx6 in x.questions)
      //   {
      //     var j=x.questions[jjx6]
      //     for(var jjx7 in this.qs.questions)
      //     {
      //     var k=this.qs.questions[jjx7]
      //      if(j.questionId==k._id_)
      //      {
      //         var xx=0;
      //         //if(cond)
      //         if(j.show )
      //         {
      //           this.showQuestion[k._id_]=cond  
      //         }
      //         //else
      //         //  this.showQuestion[questionId]=!j.show 
      //      }
      //     }
      //   }
      // }
      // while(true)
      // {

      //   this.counter--
      //   var mq= this.qs.questions[this.counter]

      //   //if question no answers
      //   var gg=this.questionAnsw[this.counter]
      //   if(!gg || Object.keys(gg).length==0 )
      //     continue;
      //   //end if

      //   if(this.showQuestion[mq._id_]!= null && typeof(this.showQuestion[mq._id_])!="undefined")
      //     if( !this.showQuestion[mq._id_])
      //     {
      //       continue
      //     }

      //   break
      // } 
      if(this.pushtoNext.length>1)
      {
        this.pushtoNext.splice(this.pushtoNext.length-1,1)
        this.counter=this.pushtoNext[this.pushtoNext.length-1]
      }
      this.reload()
      this.ss++
      //this.setState({})
    },
    nextPage:function (){

        console.log('next-------------->',this.myansw)
      window.scrollTo(0, 0);
      if(!this.startDate)
      { 
        if(this.qs.isVoice)
        {
          startRecording()

        }
        this.startDate=new Date();

      }
      //var el =this. getElementByRef('element')
      //console.log('top to :',el.scrollTop)
      //el.scrollTop=20000 
      var isend=false;
      if(!this.canNext())
        return
        this.showQuestion={}
      console.log('gegin conditions');
      var conditionCounter=0;  
      for(var jjx8 in  this.qs.conditions)
      {
        conditionCounter++;
        var x=this.qs.conditions[jjx8]
        if(x.id=="n01e9d9fe-63bf-5604-2edd-0716297472b5")
        {
          var xxxxx=0;
        }
        var cond = this.checkCondition(x.subCond)
        console.log('Condition number '+conditionCounter+ ' : ',cond)
        //this.qs.questions
        if(x.goTo && cond )
        {
          if(x.goTo==2)
          {
            isend=true;
          }
        }
        for(var jjx9 in x.questions)
        {
          var j=x.questions[jjx9]
          for(var jjx10 in this.qs.questions)
          {
            var k=this.qs.questions[jjx10]
           if(j.questionId==k._id_)
           {
              var xx=0;
              // console.log('----------------------------------')
              // console.log(k.text);
              // console.log(k._id_);
              // console.log(j.show);
              // console.log(x.id);
              
              //if(cond)
              if(j.show )
              {
                this.showQuestion[k._id_]=cond  
              }
              if(!j.show )
              {
                if(cond)
                this.showQuestion[k._id_]=false
              }
              // console.log(this.showQuestion[k._id_]);
              // console.log('--------------')
              //else
              //  this.showQuestion[questionId]=!j.show 
           }
          }
        }
      }
      if(isend)
      {
        this.counter=this.qs.questions.length-1
      }
      else
        while(true)
        {

          this.counter++

          if(this.qs.questions.length-1<=this.counter)
            break
          var mq= this.qs.questions[this.counter]
          delete this.myansw[mq.id.toString()]
          var gg=this.questionAnsw[mq.id]
          // console.log('Conds------------->',mq)
          // console.log('Conds------------->',gg)
          
          if(!gg || Object.keys(gg).length==0 )
            continue;
          if(this.showQuestion[mq._id_]!= null && typeof(this.showQuestion[mq._id_])!="undefined")
            if( !this.showQuestion[mq._id_])
            {
              continue
            }

          break
        } 
      this.pushtoNext.push(this.counter)  
      this.reload()
      
      this.calculateScore()
      // console.log(this.myansw)
    },
    opClicked:function (data){
      //console.log('--->',d
      var obj={}
      obj[data]=true
      for(var a in this.myansw[this.ques.id])
      {
        var s=this.myansw[this.ques.id][a]
        if(s==a)
          this.myansw[this.ques.id][a]=true
        else
          this.myansw[this.ques.id][a]=false
      }
      //console.log('--->',obj)

      //this.myansw[this.ques.id]=obj
    },
    calculateScore()
    {
      var sum=0; 
        for(var q of this.qs.questions)
        {
          for(var ans of q.answers)
          {
            var id=q.id+ '_'+ans.id
            if(q.id)
            {  
              if(this.myansw[q.id] && this.myansw[q.id][id])
              {
                if(ans.score)
                  sum+=parseInt(ans.score)
              }
              var dx=0;
            }
          }
        }
        this.score=sum
            console.log('calculateScore',sum)
    },
    getQuesById:function (id){
      for(var jjx11 in this.qs.questions)
      {
        var a=this.qs.questions[jjx11]
        if(a.id==id)
          return a
      }
      return {}
    },
        getMinMax:function (min,max){
      var x=[]
      for(var a=max;a>=min;a-- )
      {
        x.push(a)
      }
      return x
    },
    submit:function (){

      var t= getCookie('token')
      var anss=[]

      // console.log('ssssssssssssssssssssssss',this.myansw)
      for(var a in this.myansw)
      {
        var numk=Object.keys(this.myansw[a])
        if(numk.length==0)
          continue
        var mq=this.getQuesById(a)
        var ao={
          id:a,
          text:mq.text,
          number:mq.number,
          kind:mq.kind,
          answer:[]
        }
        for(var b in this.myansw[a])
        {
          var answ=this.myansw[a][b]
          if(answ===true)
          {
            answ=this.questionAnsw[a+""] [b].text
          }
          var adansw={
            id:b,
            text : this.questionAnsw[a+""] [b].text,
            answer:answ
          }
          if(mq.kind=="radio")
          {
            if(b[0]!="o")
              adansw.answer=this.questionAnsw[a+""] [b].text
          }
          ao.answer.push(adansw)
          //if(mq.kind)
          
        }
        anss.push(ao)
      }
      var objx={
        questionnaireId:this.thisId,
        "startDate": this.startDate,
        "endDate": new Date(),
        answer:anss
      }
      //console.log('--------------->',objx)
      var strurl=global1.apiPath+'/v1/a';
      if(this.isPublic)
      {
        strurl+='/public';
      }
      var q=httpPostData(strurl,objx,{
        'x-auth-token':t
      }) 
      //console.log('---q------------>',q)
      if(q.trackingCode)
      {
        if(this.qs.isVoice)
        {
          try{

            stopRecording()
          }catch(exp){

          }

        }
        this.ques.text="اطلاعات ارسال شد" +" کد پیگیری شما  به صورت زیر می باشد"
        this.ques.description=""
        this.trackingCode =q.trackingCode
        this.issend=true
        setTimeout(()=>{
          if(this.qs.isVoice)
          {
            try{

              stopRecording()
            }catch(exp){

            }

          }

        },1000)



      }
      else
      {
        this.ques.text="کد پیگیری دریافت نشد دوباره ارسال کنید"
      }
    },
        
    },
    
    updated:function (){ 
      $('<selector>').attr('checked', false);
    },
mounted:function (){ 
      var id=getParams(this,"id") 
      this.thisId=id
      var t= getCookie('token')
      console.log('getdata:')
      var q=httpGetData(global1.apiPath+'/v1/q/'+id,{},{
        'x-auth-token':t
      }) 
      var questcounts=0;
      for(var a of q.questions)
      {

        if(a.kind=="phone")
        {
          questcounts++;
          q.conditions.push(
            {
              id:"phonecond"+questcounts,
            goTo:2,
            subCond:{
              type:"and",
              children:[
                {
                  id:"phonecondx"+questcounts,
                  operation: "ne",
                  questionId:a.id,
                  questionnaireId:id,
                  value:"",
                  valueId:99999991
                  },
                  {
                  id:"phonecondy"+questcounts,
                  operation: "notnull",
                  questionId:a.id,
                  questionnaireId:id,
                  value:"",
                  valueId:99999991
                  }
              ]
            }
            }
          );
          a.kind=["radio"]
          a.answers=[
            {id:99999991,text:"موفق"},
            {id:99999992,text:"عدم همکاری"},
            {id:99999993,text:"خط به شخص دیگری واگذار شده"},
            {id:99999994,text:"عدم اطلاعات کافی از طرح"},
            {id:99999995,text:"اشغال"},
            {id:99999996,text:"خارج از شبکه"},
            {id:99999997,text:"خاموش"},
            {id:99999998,text:"در حال حاضر مشغول هستم بعدا تماس بگیرید"},
            {id:99999999,text:"صاحب خط در حال حاضر حضور ندارد"},
          ]
        }
      }
      //console.log('data is --->',q)
      this.isPublic= q.isPublic;
      var w=q.welcomePage
      var wobj={ 
        answers:[{text:w.buttonTitle}]
        ,kind:"page"
      }
      var eob=q.endPage
      var eobj={ 
        answers:[{text:eob.buttonTitle}]
        ,kind:"endpage"
      }

      if(eob.viewUrl)
        eobj.url=eob.media
        
      if(eob.viewTitle)
        eobj.text=eob.title
        
      if(eob.description)
        eobj.description=eob.description

      q.questions.push( eobj)       

      if(w.viewUrl)
        wobj.url=w.media

      if(w.viewButtonTitle)
        wobj.buttonTitle=w.buttonTitle
        
      if(w.viewTitle)
        wobj.text=w.title
        
      if(w.description)
        wobj.description=w.description

      q.questions.splice(0,0,wobj)  
      console.log('----------------------------------')     
      for(var jjx12 in q.questions)
      {
        var a= q.questions[jjx12] 
        this.myansw[a.id+""]={}
        this.shErr[a.id+""]={}
        for(var jjx13 in a.answers)
        {
          var b=a.answers[jjx13]
          b.mclass='form-control'
          if(b.expected)
            b.mclass+=' required'

        }
      }
      this.ques=q.questions[this.counter]
      this.qs=q
      this.getAllCond(q.conditions)
      
      this.reloadQuestion()
      this.reload()
     // console.log('getParams',dts)
    },

     
   
}
</script>